import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

const BarcodeDisplay = ({ 
  trackingNumber, 
  carrier = 'UPS', 
  size = 'medium',
  showNumber = true,
  className = ''
}) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!trackingNumber || !canvasRef.current) return;

    try {
      // Clear canvas
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Set barcode options based on carrier and size
      const barcodeOptions = {
        format: getBarcodeFormat(carrier),
        width: size === 'small' ? 1 : size === 'large' ? 3 : 2,
        height: size === 'small' ? 30 : size === 'large' ? 80 : 50,
        displayValue: showNumber,
        fontSize: size === 'small' ? 10 : size === 'large' ? 16 : 12,
        textAlign: 'center',
        textPosition: 'bottom',
        textMargin: 4,
        fontOptions: 'bold',
        font: 'monospace',
        background: '#ffffff',
        lineColor: '#000000',
        margin: size === 'small' ? 5 : 10
      };

      // Generate barcode
      JsBarcode(canvas, trackingNumber, barcodeOptions);
      
    } catch (error) {
      console.error('Error generating barcode:', error);
      
      // Fallback: show error message on canvas
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#f3f4f6';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#6b7280';
      ctx.font = '12px monospace';
      ctx.textAlign = 'center';
      ctx.fillText('Barcode Error', canvas.width / 2, canvas.height / 2);
    }
  }, [trackingNumber, carrier, size, showNumber]);

  const getBarcodeFormat = (carrier) => {
    switch (carrier?.toUpperCase()) {
      case 'UPS':
        return 'CODE128'; // UPS uses Code 128
      case 'FEDEX':
        return 'CODE128'; // FedEx uses Code 128
      case 'DHL':
        return 'CODE128'; // DHL uses Code 128
      case 'USPS':
        return 'CODE128'; // USPS uses Code 128
      default:
        return 'CODE128'; // Default to Code 128
    }
  };

  const getCanvasSize = () => {
    switch (size) {
      case 'small':
        return { width: 180, height: 45 }; // Reduced for mobile
      case 'large':
        return { width: 280, height: 80 }; // Further reduced from 350x100 for mobile
      default:
        return { width: 240, height: 60 }; // Reduced from 280x70
    }
  };

  if (!trackingNumber) {
    return null;
  }

  const canvasSize = getCanvasSize();

  return (
    <div className={`barcode-container flex justify-center ${className}`}>
      <canvas
        ref={canvasRef}
        width={canvasSize.width}
        height={canvasSize.height}
        className="max-w-full h-auto border border-gray-200 rounded bg-white"
        style={{ 
          imageRendering: 'auto',
          width: '100%',
          maxWidth: `${canvasSize.width}px`,
          display: 'block'
        }}
      />
    </div>
  );
};

export default BarcodeDisplay;